import React from "react";
import { Card as MuiCard, CardActionArea, CardContent, Tooltip } from "@mui/material";
import { focusRingInsetSx } from "../../../styles/focusRing";

// CardActionArea is a "stretched" overlay covering the whole card (position: absolute, inset: 0)
// instead of wrapping the children. That keeps the whole card as a single clickable/keyboard
// focusable control while other interactive content (e.g. a secondary icon button) can be a real
// DOM sibling raised above it with z-index - not a <button> nested inside another <button>, which
// is invalid HTML and blocks keyboard/screen reader (JAWS/NVDA) access to the inner control.
const Card = ({
  onClick,
  ariaLabel,
  // set when the overlay's aria-label already carries all the content, so it is not read twice
  hideContentFromAT = false,
  maxWidth,
  maxHeight,
  sx,
  children,
  ...props
}) => (
  <MuiCard
    elevation={0}
    sx={{
      position: "relative",
      borderRadius: "8px",
      border: "1px solid #E2E2E3",
      boxShadow: "none",
      maxWidth,
      maxHeight,
      transition: "box-shadow 0.2s ease-in-out",
      "&:hover": {
        boxShadow: "0px 4px 8px 2px rgba(0, 0, 0, 0.12)",
      },
      ...sx,
    }}
    {...props}
  >
    <Tooltip title={ariaLabel || ""}>
      <CardActionArea
        onClick={onClick}
        aria-label={ariaLabel}
        sx={{
          position: "absolute",
          inset: 0,
          borderRadius: "inherit",
          "&.MuiButtonBase-root:focus-visible": focusRingInsetSx,
        }}
      />
    </Tooltip>
    <CardContent
      aria-hidden={hideContentFromAT || undefined}
      sx={{
        width: "100%",
        height: "100%",
        padding: "16px",
        "&:last-child": { paddingBottom: "16px" },
        display: "flex",
        flexDirection: "column",
        gap: 2,
      }}
    >
      {children}
    </CardContent>
  </MuiCard>
);

export default Card;

